const user = {
  first_name: "Nombre",
  last_name: "Apellido",
  name: "Nombre",
  email: "Correo electrónico",
  gender: "Género",
  address: "Domicilio",
  phone_number: "Celular",
  birthday_with_format: "Fecha de nacimiento mm/dd/aaaa",
  birthday: "Fecha de nacimiento",
  gender_options: {
    male: "Hombre",
    female: "Mujer",
    unspecified: "Prefiero no decir",
  },
  culture: {
    mexico: "Mexico",
    el_salvador: "El Salvador",
    guatemala: "Guatemala",
    united_states: "EEUU",
    colombia: "Colombia",
    puerto_rico: "Puerto Rico",
    costa_rica: "Costa Rica",
    cuba: "Cuba",
    nicaragua: "Nicaragua",
    ecuador: "Ecuador",
    unknown: "No se",
    honduras: "Honduras",
    argentina: "Argentina",
    bolivia: "Bolivia",
    chile: "Chile",
    dominican_republic: "República Dominicana",
    panama: "Panama",
    paraguay: "Paraguay",
    peru: "Peru",
    spain: "España",
    uruguay: "Uruguay",
    venezuela: "Venezuela",
    other: "Otro"
  },
  culture_id: "Seleccione el país de origen de su familia",
  other_culture_name: "Especificar el país de origen de su familia",
  mexico_state_id: "¿De qué estado de México proviene su familia?",
  interests: "Intereses",
  language: "Idioma",
  language_options: {
    spanish: "Español",
    english: "Inglés",
  },
  profile: {
    header_title: "Su cuenta",
    logout_cta: "Cerrar sesión",
    edit_cta_title: "Información básica",
    edit_cta: "Editar",
    cancel_edit_cta: "Cancelar",
    submit_cta: "Aplicar cambios",
    payment_cta_title: "Facturación",
    payPastDue_cta: "Pagar ahora",
    gender_title: "Género",
    basic_member: {
      upgrade_premium_message: "Upgrade to premium to unlock all benifits for",
      unlock_benifit_cta: "Unlock benifits now!",
      duration: "/ month"
    },
    podercard_alert: {
      title: "¡Oh!",
      subtitle: "Como tarjetahabiente PODERcard, sólo puede hacer estos cambios en esa app.",
      open: "Abrir PODERcard",
      cancel: "Cancelar",
    },
    terms_and_condition: "Términos y Condiciones y Política de Privacidad",
  },
};

export default user;
